module.exports = __webpack_public_path__ + "img/Sammelstelle.08ddd774.svg";